import { render } from "./policy-agreement.component.vue?vue&type=template&id=96b66e7c&ts=true"
import script from "./policy-agreement.component.vue?vue&type=script&lang=ts"
export * from "./policy-agreement.component.vue?vue&type=script&lang=ts"

import "./policy-agreement.component.vue?vue&type=style&index=0&id=96b66e7c&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__